import { inject, InjectionToken } from "@angular/core";
import { PlatformType } from "src/app/common/platform-type";
import { PlatformService } from "src/app/services/platform.service";

export const PLATFORM_TOKEN = new InjectionToken<PlatformType>(
  "platform_token",
  {
    providedIn: "root",
    factory: () => {
      return inject(PlatformService).getType();
    }
  }
);

export const PLATFORM_TOKEN_V2 = new InjectionToken<{
  isDesktop: boolean;
  isMobile: boolean;
}>("platform_token_v2", {
  providedIn: "root",
  factory: () => {
    return {
      isDesktop: inject(PLATFORM_TOKEN) === PlatformType.DESKTOP,
      isMobile: inject(PLATFORM_TOKEN) === PlatformType.MOBILE
    };
  }
});
